import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";

import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { type RepeatedOpportunity } from "./entity";

export const RepeatedOpportunityEntityConfig: HyperEntityConfig<RepeatedOpportunity> =
{
  allowApiCrud: Roles.AdminsAndManager,
  apiPrefilterPerRole(filter) {
    filter(Roles.OrganizationManagers, true);
  },

  allowInsertPerRole(allow) {
    allow(Roles.OrganizationManagers, true);
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.OrganizationManagers, {
      opportunity: {
        $is: {
          organization: {
            $id: remult.user!.organizationId,
          },
        },
      },
    });
  },
};
